import * as yup from "yup";

import { PHONE_REGEXP } from "../../../../lib/globals";

const userFormSchema = yup.object().shape(
    {
        id: yup.number().when("$isAddingUser", {
            is: true,
            then: schema => schema.optional(),
            otherwise: schema => schema.required(),
        }),
        firstName: yup.string().required("First Name is required"),
        lastName: yup.string().required("Last Name is required"),
        email: yup
            .string()
            .required("Email is required")
            .email("Email is invalid"),
        phone: yup
            .string()
            .required("Phone number is required")
            .matches(PHONE_REGEXP, "Phone number is not valid"),
        city: yup.string().required("City is required"),
        state: yup.string().max(2).required("State abbreviation is required"),
        permissions: yup
            .array(
                yup.object().shape({
                    level: yup
                        .object({
                            value: yup.number().optional(),
                            label: yup.string().optional(),
                        })
                        .optional()
                        .nullable(),
                }),
            )
            .optional(),
    },
    [
        ["password", "password"],
        ["confirmPassword", "password"],
        ["confirmPassword", "confirmPassword"],
    ],
);

export default userFormSchema;
